import React from 'react';

import style from './why.module.scss';

import banner from '../../assets/image/home/why.png';

export const Why = () => {
    return (
        <div className={style.why} style={{ background: `url(${banner})` }}>
            <div className={style.whyContainer}>
                <p className={style.whyTitle}>Why Wintech Rubber & Plastics?</p>
                <p className={style.whyContent}>
                    Wintech Rubber & Plastics offers the most diverse material options in the market. We supply o-rings
                    and seals in any size, material,durometer and performance requirements. Specialty material
                    development and design support are typically available at no cost.
                </p>
            </div>
        </div>
    );
};
